require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./crches-et-garderies-1-5.json") })
        }
      }, "path---crches-et-garderies-1-5");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---crches-et-garderies-1-5!./.cache/json/crches-et-garderies-1-5.json
// module id = 389
// module chunks = 231608221292675